$shm_hitalama_guide_item $mol_view
	catalog $shm_hitalama_guide_catalog
	id \
	current false
	toggle? null
	sub <= content /$mol_view
	Menu $mol_pick
		align \bottom_left
		Anchor <= Anchor $mol_check
			aria_role \presentation
			checked false
			click? null
			sub / <= Group $mol_button_minor
				click? <=> toggle?
				event *
					^
					dblclick? <=> rename_start? null
				sub /
					<= Folder_icon $mol_icon_folder
					<= title \
		event *
			^
			contextmenu? <=> contextmenu? null
		bubble_content <= menu_content /$mol_view
	Delete $shm_confirm_delete
		title \Удалить группу
		confirmed? <=> remove? null
	Link $mol_link
		current <= current
		arg <= page_arg *
		title <= title
	Input $mol_string
		value? <=> draft? \
		submit? <=> rename_submit? null
		event *
			^
			blur? <=> rename_submit? null
			keydown? <=> rename_keydown? null
			pointerdown? <=> input_pointerdown? null
